import { styled } from 'styled-components';

import { Link } from '../Link';
import { Arrow } from '../../assets/icons';
import { getColor } from '../../utils';
import { Container, Flex, Grid } from '../Layout';
import { Crumbs } from './types';

const StyledLink = styled.span`
  * {
    color: ${getColor('black')};
  }
`;
const RotateDiv = styled.div`
  margin: 0 12px;
  transform: rotate(-90deg);
`;

type BreadcrumbsProps = {
  testId?: string;
  crumbs: Crumbs;
};

export const Breadcrumbs = ({ testId, crumbs }: BreadcrumbsProps) => {
  return (
    <Container data-testid={testId}>
      <Container marginLeft="auto" marginRight="auto" paddingTop={30} paddingBottom={28} maxWidth={1236} height={80}>
        <Grid gutterWidth={40} sidePadding={20} height="100%">
          <Grid.Row>
            <Grid.Col textAlign={'left'} verticalAlign="center">
              <Flex flexDirection={'row'}>
                {crumbs?.map((crumb, i) => (
                  <Flex key={i}>
                    {crumbs.length !== i + 1 ? (
                      <>
                        <Link hasIcon={false} to={crumb.url}>
                          {crumb.name}
                        </Link>
                        <RotateDiv>
                          <Arrow color={'black'} width={12} />
                        </RotateDiv>
                      </>
                    ) : (
                      <StyledLink>
                        <Link disabled={true} hasIcon={false} to={crumb.url}>
                          {crumb.name}
                        </Link>
                      </StyledLink>
                    )}
                  </Flex>
                ))}
              </Flex>
            </Grid.Col>
          </Grid.Row>
        </Grid>
      </Container>
    </Container>
  );
};
